module.exports = __webpack_public_path__ + "img/tech01.4c3fa20f.png";